function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#j)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M204.816 383.195V371.387L193.916 381.378L190.283 350.043L161.673 370.479L158.04 356.855L148.049 366.846V350.497L135.787 365.029L124.887 332.329L111.263 365.958L91.281 340.958L76.295 375.017V358.672L67.666 374.567L61.766 353.223L45.417 378.655L20.433 347.317L12.713 378.198L5.44701 369.569L-0.00299072 390.958H209.811L211.628 382.739L204.816 383.195Z",
  fill: "#F4F4F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.706 168.105C160.706 168.105 238.75 227.121 228.048 255.66C217.346 284.199 163.834 312.739 163.834 312.739L160.706 329.149L130.215 295.616L160.706 242.104C160.706 242.104 134.406 234.969 130.215 222.126C126.024 209.283 116.157 150.52 116.157 150.52",
  fill: "#C9256A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.711 44.245C135.002 44.245 138.481 40.7663 138.481 36.475C138.481 32.1838 135.002 28.705 130.711 28.705C126.42 28.705 122.941 32.1838 122.941 36.475C122.941 40.7663 126.42 44.245 130.711 44.245Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.016 152.041C148.016 152.041 157.616 308.771 130.497 382.977L136.162 391.3H87.924C87.924 391.3 82.654 191.949 82.654 148.921L148.016 152.041Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.602 30.777V51.145L109.37 57.345V22.974L134.602 16.774V30.777Z",
  fill: "#FFD5E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.349 37.824C120.722 37.824 121.024 37.5218 121.024 37.149C121.024 36.7762 120.722 36.474 120.349 36.474C119.976 36.474 119.674 36.7762 119.674 37.149C119.674 37.5218 119.976 37.824 120.349 37.824Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.711 37.824C131.084 37.824 131.386 37.5218 131.386 37.149C131.386 36.7762 131.084 36.474 130.711 36.474C130.338 36.474 130.036 36.7762 130.036 37.149C130.036 37.5218 130.338 37.824 130.711 37.824Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.67 41.171V30.771H132.879",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.077 30.777H124.286",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.031 36.104V39.714C110.568 39.714 110.109 39.6227 109.681 39.4455C109.254 39.2682 108.865 39.0084 108.537 38.6809C108.21 38.3533 107.95 37.9645 107.773 37.5366C107.596 37.1087 107.505 36.6501 107.505 36.187C107.505 36.079 107.51 35.972 107.519 35.866C107.717 33.677 111.031 33.905 111.031 36.104Z",
  fill: "#EDEEEF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.031 39.715C110.568 39.715 110.109 39.6238 109.681 39.4465C109.254 39.2692 108.865 39.0094 108.537 38.6819C108.21 38.3544 107.95 37.9655 107.773 37.5376C107.596 37.1097 107.505 36.6511 107.505 36.188",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.392 43.737C124.923 43.737 124.459 43.6447 124.026 43.4653C123.593 43.2859 123.2 43.023 122.868 42.6916C122.537 42.3602 122.274 41.9668 122.095 41.5338C121.915 41.1008 121.823 40.6367 121.823 40.168",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.603 51.145L109.37 57.347",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.671 41.182L125.393 41.742",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.552 35.208C112.435 34.4737 113.111 33.5222 113.514 32.4472C113.918 31.3722 114.034 30.2107 113.852 29.077C113.376 24.902 113.845 21.046 120.352 20.277C125.087 19.7913 129.846 19.5616 134.606 19.589",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.602 29.074C134.602 29.074 147.168 6.42701 123.077 1.67001C98.986 -3.08699 91.148 12.274 92.687 24.146C94.348 37.025 102.545 40.795 109.268 42.933",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.654 93.821V148.921L160.709 168.106V106.735C160.709 96.1618 157.164 85.8939 150.64 77.573C144.117 69.2521 134.992 63.3587 124.724 60.835V60.835C119.723 59.6059 114.508 59.5302 109.473 60.6136C104.438 61.697 99.7159 63.9111 95.663 67.0885C91.6101 70.2659 88.3328 74.3233 86.079 78.954C83.8253 83.5846 82.6541 88.6671 82.654 93.817V93.821Z",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.28 44.245C110.571 44.245 114.05 40.7663 114.05 36.475C114.05 32.1838 110.571 28.705 106.28 28.705C101.989 28.705 98.51 32.1838 98.51 36.475C98.51 40.7663 101.989 44.245 106.28 44.245Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.051 36.475C114.051 38.5358 113.232 40.5121 111.775 41.9693C110.318 43.4264 108.342 44.245 106.281 44.245C104.22 44.245 102.244 43.4264 100.787 41.9693C99.3296 40.5121 98.511 38.5358 98.511 36.475",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.017 152.041C148.017 152.041 157.617 308.771 130.498 382.977",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.053 68.439C94.053 68.439 73.181 83.011 69.375 121.065C65.569 159.119 113.137 192.417 163.559 137.238C163.559 137.238 178.305 126.297 178.781 117.259C179.257 108.221 160.711 119.239 160.711 119.239C160.711 119.239 165.948 116.308 160.711 115.833C155.474 115.358 154.523 120.749 154.523 120.749L109.371 128.439L116.161 99.898",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.13 156.546V186.706C118.767 195.027 139.137 157.651 139.137 157.651C116.318 171.08 95.931 167.746 83.13 156.546Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M160.713 115.833C163.064 116.047 163.301 116.755 162.852 117.471L163.569 117.677C166.642 116.002 169.92 114.735 173.321 113.907L174.978 99.025H160.078L158.159 116.125C158.978 115.839 159.851 115.739 160.713 115.833V115.833Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M105.526 44.245C105.526 44.245 98.866 83.487 118.21 80.633C137.554 77.779 166.091 70.961 163.4 99.66",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.69 64.028C133.69 64.028 175.768 78.413 181.79 80.95C181.79 80.95 181.49 46.55 178.79 44.245C176.09 41.94 171.011 33.245 176.403 30.777C176.403 30.777 171.963 19.424 174.976 19.585C177.989 19.746 178.623 24.503 183.063 25.454C187.503 26.405 234.436 93.954 210.018 113.974C192.788 128.101 174.977 125.985 174.977 125.985",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "j"
}, /*#__PURE__*/React.createElement("rect", {
  width: 229.059,
  height: 391.299,
  fill: "white"
})));

var SvgJack = function SvgJack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 392,
    viewBox: "0 0 230 392",
    fill: "none",
    className: "hidden md:block absolute left-0 bottom-0 ml-40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Jack.5e3d8506.svg";
export { ForwardRef as ReactComponent };